import "./css/Anchor.css";
export default function Anchor({
  href,
  children,
  className,
  disabled,
  ...props
}) {
  const computedClassName = [className, (disabled && "disabled") || ""]
    .join(" ")
    .trim();
  return (
    <a href={href} className={computedClassName} {...props}>
      {children}
    </a>
  );
}

Anchor.defaultProps = {
  className: "",
};
